import React, { useEffect } from 'react';
import { Row, Col, Card, Statistic, Typography } from 'antd';
import { GlobalOutlined, SolutionOutlined, PhoneOutlined, CalendarOutlined } from '@ant-design/icons';
import { useGetTourPackagesMutation, useGetInquiriesMutation, useGetLeadsMutation, useGetCustomToursMutation } from '../redux/services/apiSlice';

const { Title } = Typography;

const Dashboard = () => {
    const [getTours, { data: tours }] = useGetTourPackagesMutation();
    const [getInquiries, { data: inquiries }] = useGetInquiriesMutation();
    const [getLeads, { data: leads }] = useGetLeadsMutation();
    const [getCustomTours, { data: customTours }] = useGetCustomToursMutation();

    useEffect(() => {
        getTours();
        getInquiries();
        getLeads();
        getCustomTours();
    }, [getTours, getInquiries, getLeads, getCustomTours]);

    return (
        <div>
            <Title level={2}>Dashboard Overview</Title>
            <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
                <Col xs={24} sm={12} lg={6}>
                    <Card bordered={false} hoverable style={{ background: '#e6f7ff' }}>
                        <Statistic
                            title="Total Tour Packages"
                            value={tours?.length || 0}
                            prefix={<GlobalOutlined style={{ color: '#1890ff' }} />}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} lg={6}>
                    <Card bordered={false} hoverable style={{ background: '#f6ffed' }}>
                        <Statistic
                            title="Booking Inquiries"
                            value={inquiries?.length || 0}
                            prefix={<SolutionOutlined style={{ color: '#52c41a' }} />}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} lg={6}>
                    <Card bordered={false} hoverable style={{ background: '#fff7e6' }}>
                        <Statistic
                            title="Total Leads"
                            value={leads?.length || 0}
                            prefix={<PhoneOutlined style={{ color: '#faad14' }} />}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} lg={6}>
                    <Card bordered={false} hoverable style={{ background: '#f9f0ff' }}>
                        <Statistic
                            title="Custom Tour Requests"
                            value={customTours?.length || 0}
                            prefix={<CalendarOutlined style={{ color: '#722ed1' }} />}
                        />
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default Dashboard;
